import * as actionTypes from "./SuperAdminTypes";

const INTIAL_STATE = {
  CompaniesData: null,
  isCompaniesLoading: false,

  CompaniesDetailsData: null,
  isCompaniesDetailsLoading: false,
  error: null,
  updatingUser: false, // To track user update state


  PropmtsData: null,
  PropmtsLoading: false,

  GetPropmtsLoading: false,
};

const SuperAdminReducer = (state = INTIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case actionTypes.GET_COMPANIES_LOADING:
      return {
        ...state,
        isCompaniesLoading: true
      };
    case actionTypes.GET_COMPANIES_SUCCESS:
      return {
        ...state,
        CompaniesData: payload,
        isCompaniesLoading: false
      };
    case actionTypes.GET_COMPANIES_FAILED:
      return {
        ...state,
        isCompaniesLoading: false
      };
    ///////////////////////////////////////////////////////////////////////////////////////
    case actionTypes.GET_COMPANIES_DETAILS_LOADING:
      return {
        ...state,
        isCompaniesDetailsLoading: true
      };
    case actionTypes.GET_COMPANIES_DETAILS_SUCCESS:
      return {
        ...state,
        CompaniesDetailsData: payload,
        isCompaniesDetailsLoading: false
      };
    case actionTypes.GET_COMPANIES_DETAILS_FAILED:
      return {
        ...state,
        isCompaniesDetailsLoading: false
      };
    ///////////////////////////////////////////////////////////////////////////////////////
    case actionTypes.GET_COMPANIES_DETAILS_LOADING:
      return {
        ...state,
        isCompaniesDetailsLoading: true
      };
    case actionTypes.GET_COMPANIES_DETAILS_SUCCESS:
      return {
        ...state,
        CompaniesDetailsData: payload,
        isCompaniesDetailsLoading: false
      };
    case actionTypes.GET_COMPANIES_DETAILS_FAILED:
      return {
        ...state,
        isCompaniesDetailsLoading: false
      };
    ///////////////////////////////////////////////////////////////////////////////////////
    case actionTypes.BRAND_PORPMTS_LOADING:
      return {
        ...state,
        PropmtsLoading: true
      };
    case actionTypes.BRAND_PORPMTS_SUCCESS:
      return {
        ...state,
        PropmtsData: payload,
        PropmtsLoading: false
      };
    case actionTypes.BRAND_PORPMTS_FAILED:
      return {
        ...state,
        PropmtsLoading: false
      };
    ///////////////////////////////////////////////////////////////////////////////////////
    case actionTypes.GET_BRAND_PORPMTS_LOADING:
      return {
        ...state,
        GetPropmtsLoading: true
      };
    case actionTypes.GET_BRAND_PORPMTS_SUCCESS:
      return {
        ...state,
        PropmtsData: payload,
        GetPropmtsLoading: false
      };
    case actionTypes.GET_BRAND_PORPMTS_FAILED:
      return {
        ...state,
        GetPropmtsLoading: false
      };

    default:
      return state;
  }
};

export default SuperAdminReducer;
